module.exports = __webpack_public_path__ + "img/Menu-12.6f231295.png";